module.exports = __webpack_public_path__ + "img/马钱子粉.7b111ec7.jpg";